import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { HeaderService, Header } from 'app/common/header/header.service';
import { FooterService, Footer } from 'app/common/footer/footer.service';
import { LoaderService, Loader } from 'app/common/loader/loader.service';
import { ChatCustomerDetails } from 'app/customer/personal-details/contracts/personal-details';
import { TokenService } from 'app/token/token.service';
import { States, MerchantConfig, Application, ActiveApplication } from 'app/application/application';
import { PostAccept, CustomerRiskData, RiskStatus } from 'app/risk/risk';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ApplicationService } from 'app/application/application.service';
import { RiskService } from 'app/risk/risk.service';
import { MerchantsCardComponent } from './merchants-card/merchants-card.component';
import { environment } from 'environments/environment';
import { AwsTrackingService } from 'app/common/tracking/aws-tracking.service';
import { EventDetails } from './../common/tracking/aws-tracker';
import { StatusCard } from './models/status-card';
import { DashboardService } from './dashboard.service';
import { LoanCard } from './models/loan-card';
import { CardType } from './models/card-type.enum';
import { Router, NavigationStart, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { catchError, delay, takeUntil, repeatWhen } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { PersonalDetailsService } from 'app/customer/personal-details/personal-details.service';
import { LoanService } from '../loans/loans.service';
import { BoltCta, BoltBillData } from './constants';



@Component({
  selector: 'zest-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {

  @ViewChild(MerchantsCardComponent, { static: false }) merchantsCard: MerchantsCardComponent;

  customer: ChatCustomerDetails = { name: '', email: '' };
  status: string;
  states: States;
  clState: PostAccept;
  showShopOption: boolean;
  showAdditionalDocUpload: boolean;
  merchantConfig: MerchantConfig;
  showDocUpload: boolean;
  isDeclined: boolean;
  declinedCode: string;
  statusCard: StatusCard;
  loanCard: LoanCard;
  sessionApplication: Application;
  pollingTimer: number;
  destroyed = new Subject<any>();
  stopPolling$ = new Subject<any>();
  applications: ActiveApplication[] = [];
  allApprovedGCApplications: ActiveApplication[] = [];
  allActiveGcApplications: ActiveApplication[] = [];
  currentApplication: ActiveApplication;
  isReady: boolean;
  isVoucherView: boolean;
  showConfetti = false;
  showModal = false;
  showCongrats = false;
  googlepayFlowEnabled = false;
  flipkartUltraFlowEnabled = false;
  isClPaused = false;
  showCLiCard = false;
  cliFeatureData: any;
  cliRiskData: CustomerRiskData;
  cliAsPrimaryCard = false;
  riskStatus: RiskStatus;
  public boltMessageHeader: string;
  public boltMessageSub: string;
  public boltCtaDetails = new BoltCta();
  public showBoltCLBanner: boolean;
  public boltTotalAmount: number;

  constructor(
    private headerService: HeaderService,
    private footerService: FooterService,
    private loaderService: LoaderService,
    private tokenService: TokenService,
    private riskService: RiskService,
    private dashboardService: DashboardService,
    private applicationService: ApplicationService,
    private awsTrackingService: AwsTrackingService,
    private router: Router,
    private route: ActivatedRoute,
    private loanService: LoanService,
    private personalDetailsService: PersonalDetailsService) { }

  ngOnInit() {
    this.loanService.getBoltBannerSwitch().subscribe(res => {
      if (res && res.showBoltBanner) {
        this.getBoltCLData();
      }
    });

    this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
    this.sessionApplication = this.applicationService.getApplication();
    this.states = this.applicationService.getPreapproveStates();
    this.merchantConfig = this.tokenService.getMerchantConfig();
    this.googlepayFlowEnabled = this.tokenService.getGooglePayEnableFlag();
    this.isClPaused = this.tokenService.getClPause();
    this.route.paramMap.subscribe((params) => {
      this.status = params.get('status');
    });
    // Reset skip dashboard
    this.tokenService.setSkipDashboard(false);
    this.tokenService.setIsSignUp(false);
    // If dashboard status is present don't look up for applications
    if (this.status) {
      this.initDashboard(this.sessionApplication, this.status);
      if (this.status === 'voucher-generation') {
        this.getApprovedGCApplications();
      }
    } else {
      this.getApplicationsAndInit();
    }
    // Re-initialize dashboard in case routing back to dashboard
    this.router.events.pipe(takeUntil(this.destroyed)).subscribe((event) => {
      if (event instanceof NavigationStart && event.url === '/dashboard') {
        this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
        this.states = this.applicationService.getPreapproveStates();
        this.getApplicationsAndInit();
      }
    });

    if (this.tokenService.getFlipkartUltraFlag()) {
      this.flipkartUltraFlowEnabled = true;
    }
  }

  getApprovedGCApplications() {
    this.allApprovedGCApplications = [];
    this.applicationService.getActiveApplications().subscribe(applications => {
      // Remove restructured applications from list
      applications.filter(application => application.Flow !== 6).forEach((gc) => {
        if (gc.Status === 'Approved' && gc.IsVoucherMerchant && (gc.LoanStatus === null || gc.LoanStatus === 'Approved')) {
          this.allApprovedGCApplications.push(gc);
        }
      });
    });
  }

  getBoltCLData() {
    this.boltMessageHeader = BoltBillData.noBillHeader;
    this.boltMessageSub = BoltBillData.noBillSub;
    this.boltCtaDetails = {
      href: BoltBillData.noBillHref,
      target: '_blank',
      text: BoltBillData.noBillCtaText,
      event: BoltBillData.noBillEvent,
      type: BoltBillData.noBillCtaType
    };
    this.loanService.getBoltBills().subscribe(bills => {
      if (bills.length === 0) {
        this.showBoltCLBanner = false;
      } else if (bills.length === 1 && bills[0].billStatus === 'UNBILLED' && (!bills[0].transactions || (bills[0].transactions && bills[0].transactions.length === 0))) {
        this.showBoltCLBanner = true;
      } else {
        this.loanService.getBoltOutstandingAmount().subscribe(res => {
          this.showBoltCLBanner = true;
          this.boltTotalAmount = res.outstandingAmount;
          this.boltMessageHeader = res.outstandingAmount > 0 ? `You have shopped for ₹ ${res.outstandingAmount}` : `₹ ${res.outstandingAmount} total due`;
          this.boltCtaDetails = {
            href: '#',
            target: '',
            text: BoltBillData.billCtaText,
            event: BoltBillData.billEvent,
            type: BoltBillData.billCtaType
          };
          if (res.outstandingAmount !== 0) {
            this.boltMessageSub = BoltBillData.nonZeroBillText;
          } else {
            this.boltMessageSub = BoltBillData.zeroBillText;
          }
        }, error => {
          this.showBoltCLBanner = true;
        });
      }
    }, (error) => {
      if (error.status === 404) {
        this.showBoltCLBanner = false;
      }
    });
  }

  triggerClick(ctaDetails) {
    const { event: newEvent, type, href } = ctaDetails;
    switch (type) {
      case 'existing':
        const { access_token } = this.tokenService.getToken();
        window.location.href = environment.boltMyAccountsUrl + '?access_token=' + access_token;
        break;
      case 'new':
        window.open(
          href,
          '_blank'
        );
    }
    const event = new EventDetails(newEvent, 'event', 'triggered');
    const props = {
      totalAmount: this.boltTotalAmount
    };
    this.awsTrackingService.sendDataToFunnelWithCustomProperties(event, newEvent === 'WebApp_EmisBolt_ViewBills' ? props : {}).subscribe();
  }

  // Fetch all applications and decide on the current application status
  getApplicationsAndInit() {
    this.applications = [];
    this.allApprovedGCApplications = [];
    this.allActiveGcApplications = [];
    this.applicationService.getActiveApplications().subscribe(applications => {
      // Remove restructured applications from list
      this.applications = applications.filter(application => application.Flow !== 6);
      this.applications.forEach((gc) => {
        if (gc.Status === 'Approved' && gc.IsVoucherMerchant && (gc.LoanStatus === null || gc.LoanStatus === 'Approved')) {
          this.allApprovedGCApplications.push(gc);
        }
        if (gc.LoanStatus === 'Active') {
          this.allActiveGcApplications.push(gc);
        }
        if (this.sessionApplication && gc.ExternalId === this.sessionApplication.ApplicationId && gc.LoanStatus !== 'Active') {
          this.currentApplication = gc;
        }
      });

      // Check if applications are in progress or approved
      if (this.allActiveGcApplications.length !== this.applications.length) {
        // If current application is removed refresh the application stored in session with the latest approved application if any
        if (this.currentApplication) {
          this.initDashboard(this.sessionApplication);
        } else {
          // If more approved applications are present and current application is not declined update the session application
          if (this.allApprovedGCApplications.length && this.states && [2, 3, 5, 11, 12, 15].indexOf(this.states.loan.CurrentStatus) === -1) {
            this.applicationService.removeSavedApplication();
            this.sessionApplication = null;
            this.currentApplication = this.allApprovedGCApplications[this.allApprovedGCApplications.length - 1];
            // Fetch the Order details of the latest approved application
            this.applicationService.getOrderDetails(this.currentApplication.ExternalId).subscribe(application => {
              this.sessionApplication = application;
              // Save the latest approved application in session
              this.applicationService.sendDataToLogger('Get latest approved application in dashboard', {
                application
              }).subscribe();
              this.applicationService.saveApplication(this.sessionApplication);
              this.initDashboard(this.sessionApplication);
            });
          } else {
            this.clearSessionApplication();
            this.initDashboard(this.sessionApplication);
          }
        }
      } else {
        this.clearSessionApplication();
        this.initDashboard(this.sessionApplication);
      }
    }, error => {
      if (error.status === 404) {
        this.clearSessionApplication();
        this.initDashboard(this.sessionApplication);
      }
    });
  }

  clearSessionApplication() {
    // Clear session application if it is not declined
    if (this.states && [2, 3, 5, 11, 12, 15].indexOf(this.states.loan.CurrentStatus) === -1) {
      // Clear saved application in session
      this.applicationService.removeSavedApplication();
      this.sessionApplication = null;
    }
  }

  // Initialize the bashboard based on an application
  initDashboard(application, status = '') {
    const initData = [];
    const applicationId = application ? application.ApplicationId : null;
    const hideHeaderForETMoney = this.tokenService.getCustomMerchantConfig() || this.tokenService.getFlipkartUltraFlag();

    const customerDetails = this.tokenService.getCustomerDetails();

    if (hideHeaderForETMoney) {
      this.headerService.ShowHeaderSource.next(new Header(0, false, 0, false, '', false));
    } else {
      this.headerService.ShowHeaderSource.next(new Header(1, false, 0, false, '', false));
    }
    this.footerService.ShowFooterSource.next(new Footer(false, false, false, false, false, true));

    // Get Preapprove States Data
    initData.push(this.applicationService.getState(applicationId).pipe(
      catchError(error => {
        return of(error);
      })
    ));
    // Get CL Reactivation switch
    initData.push(this.applicationService.getCLReactivationSwitch().pipe(
      catchError(error => {
        return of(error);
      })
    ));
    // Get Credit Limit Data
    initData.push(this.riskService.checkCustomerCreditLimit().pipe(
      catchError(error => {
        return of(error);
      })
    ));

    initData.push(this.riskService.getRiskStatus().pipe(
      catchError(error => {
        return of(error);
      })
    ));

    // If name not available look up for PD details
    if (customerDetails && customerDetails.name) {
      this.customer.name = customerDetails.name.split(' ')[0];
      this.customer.email = customerDetails.email;
    } else {
      initData.push(this.personalDetailsService.getPersonalDetailsV2().pipe(
        catchError(error => {
          return of(error);
        })
      ));
    }

    // Check for Preapprove States and Credit Limit
    forkJoin(...initData).subscribe(([states, clReactivation, clState, riskStatus, pdDetails]) => {
      this.isReady = true;
      this.states = (states && states.customer) ? states : null;
      this.clState = (clState && clState.credit_limit) ? clState : null;
      this.riskStatus = riskStatus && riskStatus.decision;

      const clReactivationEnabled = clReactivation.enabled;

      this.statusCard = this.dashboardService.getCLStatus(this.states, clReactivationEnabled, this.clState, this.merchantConfig, this.isClPaused, this.riskStatus);

      if ((!states.loan.IsRiskAccepted && states.loan.KycFlowCompleted) && (this.applicationService.getMerchantId() === environment.offlineCustomMerchants.uncademyMerchantId)) {
        this.statusCard.disableCTA = true;
      }
      // Show the loan card even for cl pause, if the user have a approved CL or loan
      if ((application && application.IsVoucherMerchant) && (!this.tokenService.getFlipkartUltraFlag())) {
        this.loanCard = this.dashboardService.getLoanStatus(application, this.states, this.clState, this.statusCard, status);
      }
      if (pdDetails) {
        this.customer.name = pdDetails.SocialDetails ? pdDetails.SocialDetails.FirstName : '';
        this.customer.email = pdDetails.Contact ? pdDetails.Contact.EmailAddress : '';
      }

      // Tag users who sees the CL Pause Card for future comms
      if (this.statusCard.cardType === CardType.Paused && !this.loanCard && this.isClPaused) {
        const clPause = this.tokenService.getClPause();
        this.applicationService.tagFeatureToCustomer(clPause.featureId, clPause.version).subscribe();
      }

      if (this.loanCard && (this.loanCard.cardType === CardType.Approved || this.loanCard.cardType === CardType.OrderComplete)) {
        this.showConfetti = true;
        setTimeout(() => {
          this.showCongrats = true;
          this.showModal = true;
          this.confetti();
        }, 500);
        setTimeout(() => {
          this.showCongrats = false;
        }, 3000);
        setTimeout(() => {
          this.showModal = false;
        }, 4000);
        setTimeout(() => {
          this.showConfetti = false;
        }, 5000);
      }
      if (((this.clState && this.clState.credit_limit && clState.credit_limit.approved_amt) && (this.statusCard && this.statusCard.clLimit && this.statusCard.clLimit > 0)) && (this.clState.status_code && this.clState.status_code !== 'ZMRSK408') && (!application)) {
        const merchantId = this.merchantConfig ? this.merchantConfig.merchantId : '';
        const initCliData = [];
        // Get Feature for CLI card
        initCliData.push(this.applicationService.getFeatureVersionV2('fastlaneClIncrease', true, merchantId).pipe(
          catchError(error => {
            return of(error);
          })
        ));
        // Get Cl increase history
        const curentDate = new Date();
        curentDate.setMonth(curentDate.getMonth() - 3);
        const fromDate = this.getFormatedDate(curentDate);
        initCliData.push(this.riskService.getCustomerRiskData(fromDate).pipe(
          catchError(error => {
            return of(error);
          })
        ));
        // Get Feature for show CLI as primary card
        initCliData.push(this.applicationService.getFeatureVersionV2('cliOcdPosition', true, merchantId).pipe(
          catchError(error => {
            return of(error);
          })
        ));

        forkJoin(...initCliData).subscribe(([cliFeature, customerRiskData, cliOcdPositionFeature]) => {
          this.cliFeatureData = (cliFeature && cliFeature.version) ? cliFeature : null;
          this.cliRiskData = (customerRiskData && customerRiskData.customer_risk_decisions) ? customerRiskData : null;
          const featureEvent = new EventDetails('cli_feature_version', 'event', this.cliFeatureData ? this.cliFeatureData.version : null);
          this.awsTrackingService.sendDataToFunnelWithCustomProperties(featureEvent).subscribe();
          if ((this.cliFeatureData && this.cliFeatureData.version === 'fast_lane') && (this.clState && this.clState.credit_limit && this.clState.credit_limit.type && this.clState.credit_limit.type === 6) && (this.cliRiskData && this.cliRiskData.customer_risk_decisions.length === 0)) {
            this.showCLiCard = true;
            if (cliOcdPositionFeature && cliOcdPositionFeature.version) {
              this.cliAsPrimaryCard = cliOcdPositionFeature.version === 'primary' ? true : false;
              this.applicationService.tagFeatureToCustomerV2('cliOcdPosition', cliOcdPositionFeature.version, true, merchantId).subscribe();
            }
            const event = new EventDetails('cli_loaded', 'page', 'loaded');
            const creditValue = this.clState && this.clState.credit_limit.available_amt ? this.clState.credit_limit.available_amt : null;
            const customEventProperties = {
              cliInitialCl: creditValue,
              cli_stage: this.getCurrentState(),
              cli_primary: this.cliAsPrimaryCard
            };
            this.awsTrackingService.sendDataToFunnelWithCustomProperties(event, customEventProperties).subscribe();
          }
        }, (error) => {
          this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
          this.showCLiCard = false;
          this.cliAsPrimaryCard = false;
        });
      }
      this.logPageLoadEvent(this.loanCard, this.statusCard, application);

      // If states are available init the other components
      if (this.states) {
        if ((!this.loanCard && this.statusCard.cardType === CardType.Referred && !this.statusCard.progress.cta) || (this.loanCard && this.loanCard.cardType === CardType.Referred)) {
          // Check if the request is referred and show additional doc upload
          this.showAdditionalDocUpload = true;
        } else if (!applicationId && !this.states.customer.creditLimitActive
          && (this.states.customer.proofOfIdUploaded || this.states.customer.kycFlowCompleted)
          && this.statusCard.cardType === CardType.Approved
          && this.merchantConfig.merchantId === environment.zestMerchantId) {
          // Check if to show shop option
          this.showShopOption = true;
        }
      }
    }, (error) => {
      this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
    });
  }

  logPageLoadEvent(loanCard, statusCard, application) {
    const isRiskDecisionTaken = this.states.loan.IsRiskAccepted || this.states.loan.IsRiskDeclined || this.states.loan.IsRiskRefered;
    if (loanCard) {
      if (loanCard.cardType === CardType.Declined) {
        this.isDeclined = true;
        this.declinedCode = this.states.loan.RejectionCode ? this.states.loan.RejectionCode : this.tokenService.getRiskStatusCode();
        this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
        this.logEvent('ocd_' + this.loanCard.name + '_page', 'page', 'loaded');
      } else if
        ((this.loanCard.cardType === CardType.Referred || this.states.customer.customerType === 'Superprime')
        && this.states.loan.IsLoanAgreementAccepted && this.applicationService.getCreditLimitCust() && !isRiskDecisionTaken) {
        this.riskService.createRiskTask(application.ApplicationId).subscribe(response => {
          this.pollForLoanStatus(application);
        }, (error) => {
          this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
          this.logEvent('ocd_' + this.loanCard.name + '_page', 'page', 'loaded');
        });
      } else {
        this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
        if (loanCard.eventName) {
          this.logEventWithCustomProps(this.loanCard.eventName);
        } else {
          this.logEvent('ocd_' + this.loanCard.name + '_page', 'page', 'loaded');
        }
      }
    } else {
      if (this.statusCard.cardType === CardType.Declined) {
        this.isDeclined = true;
        this.declinedCode = this.states.customer.rejectionCode ? this.states.customer.rejectionCode : this.tokenService.getRiskStatusCode();
      }
      this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
      this.logEvent('ocd_' + statusCard.name + '_page', 'page', 'loaded');
    }
    if (['cl_active', 'cl_active_flipkartultra', 'cl_active_gpay'].indexOf(statusCard.name) >= 0) {
      // this.awsTrackingService.trackMoengageEvent('cl_active');
    }
  }

  pollForLoanStatus(application) {
    this.applicationService.getState(application.ApplicationId).pipe(repeatWhen(attempts => {
      return attempts.pipe(delay(3000));
    }), takeUntil(this.stopPolling$))
      .subscribe((response) => {
        this.states = response;
        // If Loan is rejected/approved/out of stock
        if ([2, 3, 5, 11, 12, 15, 10, 18].indexOf(this.states.loan.CurrentStatus) > -1) {
          this.stopPolling();
          this.loanCard = this.dashboardService.getLoanStatus(application, this.states, this.clState, this.statusCard);
          if (this.loanCard.name !== 'loan_progress') {
            this.logEvent('ocd_' + this.loanCard.name + '_page', 'page', 'loaded');
          }
        }
      }, (error) => {
        this.stopPolling();
        if (this.loanCard.name !== 'loan_progress') {
          this.logEvent('ocd_' + this.loanCard.name + '_page', 'page', 'loaded');
        }
      });

    this.pollingTimer = window.setTimeout(() => {
      this.stopPolling();
      if (this.loanCard.cardType === CardType.Referred) {
        this.loanCard.infoText = 'Hey! Looks like it\'s taking a little longer to process your application. You will get the status of your order via email/SMS. Thanks for your patience.';
      }
    }, 25000);
  }

  refreshDashboard() {
    this.loanCard = null;
    this.allApprovedGCApplications = [];
    this.allActiveGcApplications = [];
    this.currentApplication = null;
    this.applicationService.removeSavedApplication();
    this.sessionApplication = null;
    this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
    // Timer as the available credit limit update at Risk takes time.
    setTimeout(() => {
      if (this.states.customer.creditLimitActive) {
        this.getApplicationsAndInit();
      } else {
        this.router.navigate(['/loggedinredirect']);
      }
    }, 500);
  }

  continue() {
    if (this.states.customer.creditLimitActive && (this.states.customer.riskStage2Status === 'Approved' || this.states.customer.riskStage2Status === 'Accepted') && this.states.customer.isMandateCompleted && this.clState.status_code !== 'ZMRSK408') {
      if (this.clState.credit_limit && this.clState.credit_limit.available_amt === 0) {
        this.redirectToYourAccountUrl();
      } else {
        this.showMerchantList();
      }
    } else {
      if (Object.values(environment.offlineCustomMerchants).indexOf(this.applicationService.getMerchantId()) > -1) {
        const routeConfig = this.applicationService.getRouteConfig();
        for (const r of routeConfig) {
          r.conditions = r.conditions.replace('!states.loan.vedantuDashboard', false);
        }
        this.applicationService.updateRouteForVedantu(routeConfig);
      }
      this.applicationService.goToNextRoute('/loggedinredirect');
    }
  }

  redirectToYourAccountUrl() {
    const param = this.tokenService.getParamString();
    let url = environment.youraccountUrl + '/dashboard#' + param;
    if (this.tokenService.getReferMerchantKey()) {
      url = url + '&merchantKey=' + this.tokenService.getReferMerchantKey();
    }
    if (this.tokenService.getMerchantCustomerId()) {
      url = url + '&merchantCustomerId=' + this.tokenService.getMerchantCustomerId();
    }
    window.location.href = url;
  }

  shopOnApprovedCL() {
    this.logEvent('ocd_shop_approved_cl_click');
    this.merchantsCard.showAllMerchantsBottomSheet('open');
  }

  showMerchantList() {
    this.logEvent('ocd_merchant_view_all_click');
    this.merchantsCard.showAllMerchantsBottomSheet('open');
  }

  toggleShowDocUpload() {
    this.showDocUpload = !this.showDocUpload;
  }

  logEvent(eventName, eventType = 'event', eventValue = 'triggered') {
    const event = new EventDetails(eventName, eventType, eventValue);
    const creditValue = this.clState && this.clState.credit_limit.available_amt ? this.clState.credit_limit.available_amt : null;
    this.awsTrackingService.sendDataToFunnel(event, creditValue).subscribe();
    if (eventType === 'page') {
      this.awsTrackingService.gtmPageLoadEvent(eventName);
    } else {
      this.awsTrackingService.gtmTriggerEvent(eventName);
    }
  }

  logEventWithCustomProps(eventName, eventType = 'event', eventValue = 'triggered', props = {}) {
    const event = new EventDetails(eventName, eventType, eventValue);
    const globalProps = this.awsTrackingService.setGlobalCustomProps();
    props = { ...props, ...globalProps };
    this.awsTrackingService.sendDataToFunnelWithCustomProperties(event, props).subscribe();
    if (eventType === 'page') {
      this.awsTrackingService.gtmPageLoadEvent(eventName);
    } else {
      this.awsTrackingService.gtmTriggerEvent(eventName);
    }
  }

  stopPolling() {
    this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
    this.stopPolling$.next();
    this.stopPolling$.complete();
  }

  setVoucherView(isVoucherView) {
    this.isVoucherView = isVoucherView;
  }

  confetti() {
    const mp = 150;
    let canvas;
    let ctx;
    let W;
    let H;
    let particles = [];
    let angle = 0;
    let tiltAngle = 0;
    let confettiActive = true;
    let animationComplete = true;
    let animationHandler;

    const particleColors = {
      colorOptions: ['DodgerBlue', 'OliveDrab', 'Gold', 'pink', 'SlateBlue', 'lightblue', 'Violet', 'PaleGreen', 'SteelBlue', 'SandyBrown', 'Chocolate', 'Crimson'],
      colorIndex: 0,
      colorIncrementer: 0,
      colorThreshold: 10,
      getColor: function () {
        if (this.colorIncrementer >= 10) {
          this.colorIncrementer = 0;
          this.colorIndex++;
          if (this.colorIndex >= this.colorOptions.length) {
            this.colorIndex = 0;
          }
        }
        this.colorIncrementer++;
        return this.colorOptions[this.colorIndex];
      }
    };

    const requestAnimFrame = (function () {
      return window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        function (callback) {
          return window.setTimeout(callback, 1000 / 60);
        };
    })();

    function confettiParticle(color) {
      this.x = Math.random() * W; // x-coordinate
      this.y = (Math.random() * H) - H; // y-coordinate
      this.r = RandomFromTo(10, 30); // radius;
      this.d = (Math.random() * mp) + 10; // density;
      this.color = color;
      this.tilt = Math.floor(Math.random() * 10) - 10;
      this.tiltAngleIncremental = (Math.random() * 0.07) + .05;
      this.tiltAngle = 0;

      this.draw = function () {
        ctx.beginPath();
        ctx.lineWidth = this.r / 2;
        ctx.strokeStyle = this.color;
        ctx.moveTo(this.x + this.tilt + (this.r / 4), this.y);
        ctx.lineTo(this.x + this.tilt, this.y + this.tilt + (this.r / 4));
        return ctx.stroke();
      };
    }

    function SetGlobals() {
      canvas = document.getElementById('confetti');
      ctx = canvas.getContext('2d');
      W = window.innerWidth;
      H = window.innerHeight;
      canvas.width = W;
      canvas.height = H;
    }

    function InitializeConfetti() {
      particles = [];
      animationComplete = false;
      for (let i = 0; i < mp; i++) {
        const particleColor = particleColors.getColor();
        particles.push(new confettiParticle(particleColor));
      }
      StartConfetti();
    }

    function Draw() {
      ctx.clearRect(0, 0, W, H);
      const results = [];
      for (let i = 0; i < mp; i++) {
        (function (j) {
          results.push(particles[j].draw());
        })(i);
      }
      Update();

      return results;
    }

    function RandomFromTo(from, to) {
      return Math.floor(Math.random() * (to - from + 1) + from);
    }

    function Update() {
      let remainingFlakes = 0;
      let particle;
      angle += 0.01;
      tiltAngle = tiltAngle + 0.1;

      for (let i = 0; i < mp; i++) {
        particle = particles[i];
        if (animationComplete) {
          return;
        }

        if (!confettiActive && particle.y < -15) {
          particle.y = H + 100;
          continue;
        }

        stepParticle(particle, i);

        if (particle.y <= H) {
          remainingFlakes++;
        }
        CheckForReposition(particle, i);
      }

      if (remainingFlakes === 0) {
        StopConfetti();
      }
    }

    function CheckForReposition(particle, index) {
      if ((particle.x > W + 20 || particle.x < -20 || particle.y > H) && confettiActive) {
        if (index % 5 > 0 || index % 2 === 0) {
          repositionParticle(particle, Math.random() * W, -10, Math.floor(Math.random() * 10) - 20);
        } else {
          if (Math.sin(angle) > 0) {
            // Enter from the left
            repositionParticle(particle, -20, Math.random() * H, Math.floor(Math.random() * 10) - 20);
          } else {
            // Enter from the right
            repositionParticle(particle, W + 20, Math.random() * H, Math.floor(Math.random() * 10) - 20);
          }
        }
      }
    }
    function stepParticle(particle, particleIndex) {
      particle.tiltAngle += particle.tiltAngleIncremental;
      particle.y += (Math.cos(angle + particle.d) + 3 + particle.r / 2) / 2;
      particle.x += Math.sin(angle);
      particle.tilt = (Math.sin(particle.tiltAngle - (particleIndex / 3))) * 15;
    }

    function repositionParticle(particle, xCoordinate, yCoordinate, tilt) {
      particle.x = xCoordinate;
      particle.y = yCoordinate;
      particle.tilt = tilt;
    }

    function StartConfetti() {
      W = window.innerWidth;
      H = window.innerHeight;
      canvas.width = W;
      canvas.height = H;
      (function animloop() {
        if (animationComplete) {
          return null;
        }
        animationHandler = requestAnimFrame(animloop);
        return Draw();
      })();
    }

    function ClearTimers() {
      clearTimeout(animationHandler);
    }

    function DeactivateConfetti() {
      confettiActive = false;
      ClearTimers();
    }

    function StopConfetti() {
      animationComplete = true;
      if (ctx === undefined) {
        return;
      }
      ctx.clearRect(0, 0, W, H);
    }

    SetGlobals();
    InitializeConfetti();
    setTimeout(() => {
      DeactivateConfetti();
    }, 2000);
  }


  getFormatedDate(inputDate: Date) {
    const date = inputDate.getDate();
    const month = inputDate.getMonth();
    const year = inputDate.getFullYear();
    const hours = inputDate.getHours();
    const minutes = inputDate.getMinutes();
    const sec = inputDate.getSeconds();
    return `${year}-${month}-${date} ${hours}:${minutes}:${sec}`;
  }

  getCurrentState() {
    let currentState = '';
    if (this.states.customer.isMandateCompleted) {
      currentState = 'post_mandate';
    } else if (this.states.customer.kycFlowCompleted) {
      currentState = 'post_kyc';
    } else {
      currentState = 'post_r2';
    }
    return currentState;
  }

  ngOnDestroy(): void {
    clearTimeout(this.pollingTimer);
    this.destroyed.next();
    this.destroyed.complete();
  }
}
